import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";

import NavigateHeader from "../layout/NavigateHeader";
import { NextBonusButton } from "../buttons/NextBonusButton";
import LottieFirework from "../gadgets/LottieFirework";

const GameLayout = ({ children }) => {
  const game = useSelector(({ game }) => game);
  const { country, selectedGame } = game;
  return (
    <Fragment>
      {country.completed && <NavigateHeader />}
      <AnimatePresence mode="wait">
        <motion.div
          key={selectedGame?.key ? selectedGame.key : "country"}
          initial={{ opacity: 0, scale: 0.7 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.7 }}
          transition={{ duration: 0.2 }}
          className="relative flex min-h-96 w-full flex-col items-center justify-center gap-2 px-2"
        >
          {children}
          {country.completed && <NextBonusButton />}
          <LottieFirework trigger={game[selectedGame.key]?.isCorrect} />
        </motion.div>
      </AnimatePresence>
    </Fragment>
  );
};

export default GameLayout;
